export enum TaskPriorityLevels {
  lowest = "lowest",
  low = "low",
  medium = "medium",
  high = "high",
  highest = "highest",
}

export enum TaskStatuses {
  todo = "todo",
  in_progress = "in_progress",
  done = "done",
}

export enum CommunicationType {
  call = "call",
  task = "task",
  email = "email",
  sms = "sms",
  note = "note",
  ai_agent = "ai_agent",
}

export enum CommunicationToolItemType {
  call = "call",
  call_note = "call_note",
  sms = "sms",
  email = "email",
  task = "task",
  webhook = "webhook",
  reset_ring_central = "reset_ring_central",
}

export enum CallDisposition {
  no_answer = "no_answer",
  vm = "vm",
  made_contact = "made_contact",
  spoke_with_dm = "spoke_with_dm",
  bad_number = "bad_number",
  discovery_call = "discovery_call",
  offer_presentation = "offer_presentation",
}

export enum CallSessionStatus {
  Created = "created",
  Initiated = "initiated",
  Ringing = "ringing",
  InProgress = "in_progress",
  Answered = "answered",
  Unreachable = "unreachable",
  Busy = "busy",
  Failed = "failed",
  Canceled = "canceled",
}

export enum CalleeType {
  Business = "business",
  PersonalInformation = "owner",
  IndividualProfile = "individual_profile",
  BusinessProfile = "business_profile",
}

export enum LogEndpointType {
  CallSession = "call_sessions",
  Task = "tasks",
  Sms = "sms",
}

export enum TelephoneStatus {
  Active,
  DoNotContact,
  BadNumber,
}

export enum EmailProvider {
  Gmail = "gmail",
  AWS = "aws_sns",
}

export enum PhoneSelectionType {
  Manual = "manual",
  Auto = "auto",
}

export enum MailIntegrationType {
  Gmail = "gmail",
  Default = "default",
}

export enum NoteTab {
  All = "all",
  Recent = "recent",
  Pinned = "pinned",
}

export enum CallErrorReason {
  MissingApiResponse = "missing_api_response",
  MissingDeal = "missing_deal",
  MissingPhone = "missing_phone_number",
  StandaloneCallMissingApiResponse = "standalone_call_missing_api_response",
  UnmatchedContact = "unmatched_contact",
  Unknown = "unknown_error",
}

export enum TAB_VIEW {
  INBOX = "inbox",
  MY_ACTIVITIES = "my_activities",
  SENT = "sent",
  DEAL_INBOX = "deal_inbox",
  OUTGOING = "outgoing",
  SPAM = "spam",
  TRASH = "trash",
  AI_AGENT_INBOX = "ai_agent_inbox",
}
